import { render, staticRenderFns } from "./CreateOnOrdenes.vue?vue&type=template&id=1afe946e&"
import script from "./CreateOnOrdenes.vue?vue&type=script&lang=js&"
export * from "./CreateOnOrdenes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports